import { AxiosError } from 'axios';
import i18next from 'i18next';
import CancellableRequest from '../../cancellable-request';

export interface BackendResponseData<T = any> {
  message?: string;
  errors?: T;
  [key: string]: any;
}

class HttpError<T = any> {
  message: string;
  errors: BackendResponseData<T>['errors'] | null;
  status: number;
  isRequestCancelError: boolean;
  originalResponse: BackendResponseData | undefined;

  constructor(e: AxiosError<BackendResponseData>) {
    const getMessage = () => {
      const responseErrors = e.response?.data?.errors;
      if (Array.isArray(responseErrors) && typeof responseErrors[0] === 'string') {
        return responseErrors[0];
      }
      return e.response?.data?.message || e.message || i18next.t('somethingWentWrong');
    };

    const isRequestCancelError = CancellableRequest.isCancelled(e);
    this.message = isRequestCancelError ? 'Request was cancelled' : getMessage();
    this.errors = e.response?.data?.errors || null;
    this.status = e.response?.status || 400;
    this.isRequestCancelError = isRequestCancelError;
    this.originalResponse = e.response?.data;
  }

  static isHttpError<T = any>(e: any): e is HttpError<T> {
    return e instanceof HttpError && !e.isRequestCancelError;
  }
}

export default HttpError;